import React from 'react';
import { i18n } from 'config/locales';
import ValidationElement from 'components/Form/ValidationElement';
import Field from 'components/Form/Field';
import DateRange from 'components/Form/DateRange';
import Currency from 'components/Form/Currency';
import Textarea from 'components/Form/Textarea';
import { ValidationElementProps } from '../../../Form/ValidationElement/ValidationElement';
import {
  CommonOnUpdate,
  CommonOnError,
  CommonScrollIntoView,
  CommonRequired,
} from '../../../../types/props';
import { ErrorCode } from '../../../../redux/modules/application/reducers/error';
import { FinancialGamblingItemModel } from '../../../../forms/sections/financial/gambling/types';

interface Props extends Partial<FinancialGamblingItemModel>, ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  required?: CommonRequired
  scrollIntoView?: CommonScrollIntoView
}

export default class GamblingItem extends ValidationElement<Props> {
  update = (queue: Partial<FinancialGamblingItemModel>) => {
    this.props.onUpdate({
      Dates: this.props.Dates,
      Losses: this.props.Losses,
      Description: this.props.Description,
      Actions: this.props.Actions,
      ...queue,
    });
  };

  updateDates = (values: FinancialGamblingItemModel['Dates']) => {
    this.update({
      Dates: values,
    });
  };

  updateLosses = (values: FinancialGamblingItemModel['Losses']) => {
    this.update({
      Losses: values,
    });
  };

  updateDescription = (values: FinancialGamblingItemModel['Description']) => {
    this.update({
      Description: values,
    });
  };

  updateActions = (values: FinancialGamblingItemModel['Actions']) => {
    this.update({
      Actions: values,
    });
  };

  render() {
    const attribute = `List.items[${this.props.$index}].Item`;
    return (
      <div className="gambling-item">
        <Field
          title={i18n.t('financial.gambling.heading.dates')}
          scrollIntoView={this.props.scrollIntoView}
          adjustFor="daterange"
          attribute={`${attribute}.Dates`}
        >
          <DateRange
            name="Dates"
            {...this.props.Dates}
            className="dates"
            label={i18n.t('financial.gambling.label.dates')}
            minDateEqualTo
            onUpdate={this.updateDates}
            onError={this.props.onError}
            required={this.props.required}
            hideFromDay
            hideToDay
            attribute={`${attribute}.Dates`}
          />
        </Field>

        <Field
          title={i18n.t('financial.gambling.heading.losses')}
          scrollIntoView={this.props.scrollIntoView}
          attribute={`${attribute}.Losses`}
        >
          <Currency
            name="Losses"
            {...this.props.Losses}
            className="losses"
            min="1"
            onUpdate={this.updateLosses}
            onError={this.props.onError}
            required={this.props.required}
            attribute={`${attribute}.Losses`}
          />
        </Field>

        <Field
          title={i18n.t('financial.gambling.heading.description')}
          scrollIntoView={this.props.scrollIntoView}
          help="financial.gambling.help.description"
          attribute={`${attribute}.Description`}
        >
          <Textarea
            name="Description"
            {...this.props.Description}
            className="description"
            onUpdate={this.updateDescription}
            onError={this.props.onError}
            required={this.props.required}
            attribute={`${attribute}.Description`}
          />
        </Field>

        <Field
          title={i18n.t('financial.gambling.heading.actions')}
          scrollIntoView={this.props.scrollIntoView}
          help="financial.gambling.help.actions"
          attribute={`${attribute}.Actions`}
        >
          <Textarea
            name="Actions"
            {...this.props.Actions}
            className="actions"
            onUpdate={this.updateActions}
            onError={this.props.onError}
            required={this.props.required}
            attribute={`${attribute}.Actions`}
          />
        </Field>
      </div>
    );
  }
}

GamblingItem.defaultProps = {
  onUpdate: (queue) => {},
  onError: (value, arr: ErrorCode) => arr,
  required: false,
};
